import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

// Style config helpers for the 'Table' component
const { definePartsStyle, defineMultiStyleConfig } =
    createMultiStyleConfigHelpers([
        "table",
        "thead",
        "tbody",
        "tr",
        "th",
        "td",
        "caption",
    ]);

// Custom variants for table elements
const tableVariants = defineMultiStyleConfig({
    // Your existing table styles here
    baseStyle: definePartsStyle({
        table: {
            fontVariantNumeric: "lining-nums tabular-nums",
            borderCollapse: "collapse",
            width: "full",
        },
        th: {
            fontSize: "16px",
            color: "darkGrey",
            textTransform: "none",
        },
        td: {
            textAlign: "start",
            fontSize: "14px",
        },
        caption: {
            mt: 4,
            fontFamily: "heading",
            textAlign: "center",
            fontWeight: "medium",
        },
    }),
    // All variant styles...
    variants: {
        simple: definePartsStyle({
            /* ... */
        }),
        bordered: definePartsStyle({
            /* ... */
        }),
        rowBordered: definePartsStyle({
            /* ... */
        }),
        compact: definePartsStyle({
            /* ... */
        }),
    },
    defaultProps: {
        variant: "simple",
        size: "md",
    },
});

// Define the base theme with all components included
const baseTheme = {
    // Common color palette (can be overridden by client themes)
    colors: {
        primary: "#1b4748",
        primaryHover: "#286061",
        secondary1: "#F8641E",
        secondary2: "rgba(248, 100, 30, 0.7)",
        accent1: "#FF4800",
        darkGray: "#363636",
        lightGray: "#f9f9f9",
        textActive: "white",
        textInactive: "black",
    },

    fonts: {
        heading: "Arial, sans-serif",
        body: "Arial, sans-serif",
    },

    logo: {
        src: "assets/BP-logo-white.svg",
        alt: "BetaPersona Logo",
    },

    // All component styles included here
    components: {
        Table: tableVariants,
        Button: {
            variants: {
                active: {
                    borderColor: "primary",
                    borderWidth: "2px",
                    color: "primary",
                },
                dashboardButton: {
                    bg: "primary",
                    borderRadius: "100px",
                    color: "#ffffff",
                    _hover: {
                        bg: "primaryHover",
                    },
                },
                "outline-rounded": {
                    border: "1px solid black",
                    color: "black",
                    borderRadius: "5px",
                    _hover: {
                        bg: "secondary2",
                    },
                },
                "pill-bgOpaque": {
                    color: "white",
                    borderRadius: "100px",
                    background: "rgba(244, 244, 244, 0.12)",
                    _hover: {
                        bg: "rgba(244, 244, 244, 0.30)",
                    },
                },
                "noBorder-bgOpaque": {
                    color: "white",
                    borderRadius: "0",
                    _hover: {
                        bg: "rgba(244, 244, 244, 0.30)",
                    },
                },
                "pill-bgOrange": {
                    color: "white",
                    fontWeight: "bold",
                    borderRadius: "100px",
                    background: "#F8641E",
                    _hover: {
                        bg: "rgba(248, 100, 30, 0.7)",
                    },
                },
            },
        },
        Text: {
            variants: {
                tableBodyCell: {
                    padding: "4",
                    border: "1px",
                    borderColor: "gray.200",
                    color: "darkGrey",
                },
            },
        },
    },
};

export default baseTheme;
